import { render, staticRenderFns } from "./CreateVesselBuilderModal.vue?vue&type=template&id=66ca241d&"
import script from "./CreateVesselBuilderModal.vue?vue&type=script&lang=js&"
export * from "./CreateVesselBuilderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports